export type SettingPageTabs =
  | 'members'
  | 'organizations'
  | 'projects'
  | 'account'
  | 'shared_pages'
  | 'interactions_access'
  | 'filters'
  | 'integration'
  | 'remote_access'
  | 'alert_settings';

export const SETTINGS_ACCOUNT_PATH = '/settings/account';

export function getSettingsSectionPath(section: SettingPageTabs): string {
  switch (section) {
    case 'members':
      return '/settings/members';
    case 'organizations':
      return '/settings/organizations';
    case 'projects':
      return '/settings/projects';
    case 'account':
      return '/settings/account';
    case 'shared_pages':
      return '/settings/shared-pages';
    case 'interactions_access':
      return '/settings/interactions-access';
    case 'filters':
      return '/settings/filters';
    case 'integration':
      return '/settings/integrations';
    case 'remote_access':
      return '/settings/remote-access';
    case 'alert_settings':
      return '/settings/alerts';
  }
}

export function getSettingsSectionFromPath(pathname: string): SettingPageTabs | null {
  switch (pathname) {
    case '/settings/members':
      return 'members';
    case '/settings/organizations':
      return 'organizations';
    case '/settings/projects':
      return 'projects';
    case '/settings/account':
      return 'account';
    case '/settings/shared-pages':
      return 'shared_pages';
    case '/settings/interactions-access':
      return 'interactions_access';
    case '/settings/filters':
      return 'filters';
    case '/settings/integrations':
      return 'integration';
    case '/settings/remote-access':
      return 'remote_access';
    case '/settings/alerts':
      return 'alert_settings';
    default:
      return null;
  }
}
